/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Sts_DescriptionInputs */



/**
* | output |
* | --- |
* | "Assessments of ship-to-ship transfer service providers." |
*
* @param {Service_Sts_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_sts_description = /** @type {((inputs?: Service_Sts_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Sts_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("对船对船过驳服务商的评估。")
	return /** @type {LocalizedString} */ ("Assessments of ship-to-ship transfer service providers.")
});